<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Search uploaded (or imported) excel files</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Close
                </v-btn>
               
            </v-toolbar-items>
        </v-toolbar>


        <v-card-text
            style="padding-top: 15px;"
        >

            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
            >
            
                <template v-slot:item.date="{ item }">
                    {{$rc.pretty(item.uploaded_time,'date')}}
                </template>

                 <template v-slot:item.time="{ item }">
                    {{$rc.pretty(item.uploaded_time,'time')}}
                </template>

                <template v-slot:item.size_in_bytes="{ item }">
                    {{$rc.pretty(item.size_in_bytes,'file_size')}}
                </template>

                <template v-slot:item.download="{ item }">
                    <v-icon
                        v-on:click="onClickDownload(item)"
                    >
                        mdi-download
                    </v-icon>
                </template>
            
            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            is_valid: true,

            results: null,
            headers: [
                { text: 'Date', value: 'date'},
                { text: 'Time', value: 'time'},
                { text: 'File Name', value: 'label' },
                { text: 'Size', value: 'size_in_bytes' },
                { text: 'Uploaded By', value: 'uploaded_by_employee_label'},
                { text: 'Uploaded By (Username)', value: 'uploaded_by_employee_username'},
                { text: 'Download', value: 'download'},
            ],
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;

            let bulk_message_id = this.$route.params.bulk_message_id;
            let organization_id = this.$route.params.organization_id;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/blobs/search',
            
                {
                    'organization_id' : organization_id,
                    'bulk_message_id' : bulk_message_id,
                    'sort': 'uploaded_time:asc',
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
    
            this.dialog = false;
            next(false);
            return;
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onClickDownload(item)
        {
            this.$rc.openBlob(item.object_name);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>